<sc-modal-wizard #modal>

	<sc-modal-header>
		<div>
			<span class="oneline">{{ texts.title[language] }}</span>
		</div>
	</sc-modal-header>

	<sc-modal-wizard-page [definesHeight]="true" #request>
		<sc-modal-body *ngIf="project">
			<div class="d-flex flex-column justify-content-center h-100">
				<p class="mb-5">
					{{ texts.body[language] }}
				</p>
				<div class="fw-bold mb-2">{{ texts.commentLabel[language] }}</div>
				<textarea class="form-control" rows="4" [(ngModel)]="comment" [placeholder]="texts.commentPlaceholder[language]"></textarea>
			</div>
		</sc-modal-body>
		<sc-modal-footer>
			<button class="btn btn-round btn-secondary" (click)="modal.dismiss()">{{ texts.cancel[language] }}</button>
			<button class="btn btn-round btn-dark" (click)="requestAnalysis()" [class.loading]="isRequesting">{{ texts.requestAnalysis[language] }}</button>
		</sc-modal-footer>
	</sc-modal-wizard-page>

	<sc-modal-wizard-page #confirmation>
		<sc-modal-body>
			<div class="d-flex flex-column justify-content-center align-items-center text-center h-100 px-lg-5 py-5">
				<h4 class="mb-3">{{ texts.thankYou[language] }}</h4>
				<p class="mb-0">
					{{ texts.confirmation[language] }}
				</p>
			</div>
		</sc-modal-body>
		<sc-modal-footer>
			<button class="btn btn-round btn-secondary" (click)="modal.dismiss()">{{ texts.close[language] }}</button>
		</sc-modal-footer>
	</sc-modal-wizard-page>

</sc-modal-wizard>
